import { darken } from "polished"
import { SESSION_TERMINATED, USER_EXPIRED, USER_SIGNED_OUT, USER_EXPIRING } from "redux-oidc"
import { DEFAULTTHEME } from "../../constants"
/** This is the default state before any user-based filter restrictions are loaded */
const initialUserDetailsState = {
  id: 0,
  isAdmin: false,
  hasSubEmployees: false,
  client: {
    id: 0,
    name: "Talent Toolbox",
    subdomain: null,
    availableCultures: [{ Code: "en-GB", Name: "English" }],
  },
  authenticated: false,
  culture: "en-GB",
  theme: DEFAULTTHEME,
}

/** Manipulate the user state depending on the action type/params */
export default function userDetailReducer(state = initialUserDetailsState, action) {
  /** Remember that state is immutable - don't change/mutate
   * the incoming state, create a new state object and return that
   */
  switch (action.type) {
    case "USER_SESSION_EXPIRED":
      return { ...state, authenticated: false }
    case "SET_USER_DETAILS":
      return Object.assign({}, state, {
        id: action.user.Id,
        isAdmin: action.user.IsAdmin,
        hasSubEmployees: action.user.HasSubEmployees,
        client: {
          id: action.user.Client.Id,
          name: action.user.Client.Name,
          subdomain: action.user.Client.Subdomain,
          availableCultures: action.user.Client.AvailableCultures,
        },
        authenticated: action.authenticated,
        culture: action.user.Culture,
        theme: {
          primaryColor: action.user.Client.Theme,
          primaryColorHover: darken(0.2, action.user.Client.Theme),
          navBackgroundColor: darken(0.2, action.user.Client.Theme),
        },
      })
    case USER_EXPIRED:
    case USER_SIGNED_OUT:
    case SESSION_TERMINATED:
      return { ...state, authenticated: false }
    case USER_EXPIRING:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/userDetailReducer.js